import { withInstall } from 'element-plus/es/utils/index.mjs'
import Mention from './mention.vue'

import type { SFCWithInstall } from 'element-plus/es/utils'

export const ElMention: SFCWithInstall<typeof Mention> = withInstall(Mention)
export default ElMention

export * from './mention'
